// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__gZDFL","copyrightText":"styles_copyrightText__ILEQ2","sticky":"styles_sticky__IB6u7"};